require('./lbaPerDiem.scss');
const $inject = [];
const lbaPerDiem = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaPerDiemCtrl',
    controllerAs: 'vm',
    template: require('./lbaPerDiem.html')
  }
};

lbaPerDiem.$inject = $inject;

export default lbaPerDiem;


// WEBPACK FOOTER //
// ./src/components/lbaPerdiem/lbaPerDiemDir.js